<template>
  <div class="addInstitutionalFramework">
    <div class="newsDetial-header">
      <div class="newsDetial-title">{{ title }}</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract" v-if="!id">
        请按照系统要求填写机构信息，创建和修改机构
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont">
      <div class="detial-cont-title">机构基本信息</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="上级目录">
            <a-tree-select
              v-model="Form.parentId"
              class="w300"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="请选择上级目录"
              tree-default-expand-all
              :replaceFields="replaceFields"
              :disabled="isCreate == 1 || Form.parentId == 0"
              @change="treeChange"
            >
            </a-tree-select>
          </a-descriptions-item>
          <a-descriptions-item label="机构名称">
            <a-input
              class="w300"
              placeholder="请添加机构/部门名称"
              v-model="Form.organizationName"
              :disabled="isCreate == 1"
              @change="eightyfive('organizationName')"
            />
          </a-descriptions-item>
          <a-descriptions-item label="机构类型">
            <a-select
              placeholder="请选择机构类型"
              class="w300"
              v-model="Form.flag"
              :disabled="isCreate == 1"
            >
              <a-select-option :value="1">部门</a-select-option>
              <a-select-option :value="2" :disabled="isFlag !== 2"
                >公司</a-select-option
              >
            </a-select>
          </a-descriptions-item>
          <!-- <br /> -->
          <!-- 公司 -->
          <template v-if="Form.flag == 2">
            <a-descriptions-item label="行政主要领导">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('administrativeDirectors')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('administrativeDirectors', '选择行政主要领导')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item label="党政主要领导">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('governmentDirectors')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('governmentDirectors', '选择党政主要领导')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item
              label="查看分管领导"
              v-if="Form.flag == 2 && Form.parentId != 0"
            >
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('showLeadershipIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('showLeadershipIds', '选择查看分管领导')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <br v-else />
            <a-descriptions-item label="系统管理员">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('systemAdminIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('systemAdminIds', '选择系统管理员')"
              >
                选择
              </a-button>
            </a-descriptions-item>
          </template>

          <!-- 部门 -->
          <template v-if="Form.flag == 1">
            <a-descriptions-item label="部门负责人">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('departmentHeadIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('departmentHeadIds', '选择部门负责人')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item label="业务负责人">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('businessHeadIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('businessHeadIds', '选择业务负责人')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item label="审批分管领导">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('approveLeadershipIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('approveLeadershipIds', '选择审批分管领导')"
              >
                选择
              </a-button>
            </a-descriptions-item></template
          >
          <!-- 机构名称里有财务二字才显示财务经办人 -->
          <template v-if="isfinance">
            <a-descriptions-item label="财务经办人">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('financeAffairsIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('financeAffairsIds', '选择财务经办人')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item label="部门查看分管领导" v-if="Form.flag == 1">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('showdepartmentsHeadIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('showdepartmentsHeadIds', '选择部门查看分管领导')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <br v-else />
            <br />
          </template>
          <template
            v-if="
              Form.flag == 1 &&
                Form.organizationName != '综合办公室' &&
                !isfinance
            "
          >
            <a-descriptions-item label="部门查看分管领导">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('showdepartmentsHeadIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('showdepartmentsHeadIds', '选择部门查看分管领导')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <br />
            <br />
          </template>
          <!-- 综合办公室 -->
          <template
            v-if="Form.flag == 1 && Form.organizationName == '综合办公室'"
          >
            <a-descriptions-item label="文印人员">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('generalChiefIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('generalChiefIds', '选择文印人员')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item label="综合办信息工作人员">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('generalInfoIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('generalInfoIds', '选择综合办信息工作人员')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item label="综合办文秘人员">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('generalSecretarialIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('generalSecretarialIds', '选择综合办文秘人员')"
              >
                选择
              </a-button>
            </a-descriptions-item>
            <a-descriptions-item label="部门查看分管领导" v-if="Form.flag == 1">
              <a-input
                class="w200"
                placeholder="请选择"
                :value="getUserNames('showdepartmentsHeadIds')"
                :disabled="isCreate == 1"
                readonly
              />
              <a-button
                type="primary"
                class="ml10"
                :disabled="isCreate == 1"
                @click="openUserModal('showdepartmentsHeadIds', '选择部门查看分管领导')"
              >
                选择
              </a-button>
            </a-descriptions-item>
          </template>
          <a-descriptions-item label="自定义部门id">
            <a-input
              class="w300"
              placeholder="请输入"
              v-model="Form.organizationNumber"
              :disabled="isCreate == 1"
              @change="eightyfive('organizationNumber')"
            />
          </a-descriptions-item>
          <div v-if="Form.flag == 1"></div>
          <div v-if="Form.flag == 1"></div>
          <div v-if="Form.flag == 2"></div>
          <div v-if="!Form.flag"></div>
          <div v-if="!Form.flag"></div>
          <a-descriptions-item label="机构职能介绍">
            <a-input
              class="w500"
              v-model="Form.description"
              placeholder="请添加正文"
              type="textarea"
              :rows="5"
              :disabled="isCreate == 1"
              @change="eightyfive('description')"
            />
          </a-descriptions-item>
        </a-descriptions>
        <div class="configuration">
          <div class="configuration-title">机构业务审批流程配置</div>
          <div class="scrollX">
            <div class="configuration-cont">
              <div
                @click="showModal"
                class="business-cont"
                v-for="(i, index) in Form.useAppIds"
                :key="index"
              >
                <div class="business-imgbgc">
                  <a-icon class="business-img" :type="getApp(i).imgField" />
                </div>
                <div class="business-name">{{ getApp(i).appName }}</div>
              </div>
              <div
                class="business-cont"
                @click="showModal"
                v-if="isCreate == 2"
              >
                <div class="business-addbgc">+</div>
                <div class="business-name">添加业务</div>
              </div>
            </div>
          </div>

          <!-- 新增复选框组  备注：只有公司有此权限部门没有此权限-->
          <div class="checkbox-groupContent" v-if="Form.flag == 2">
            <div class="configuration-title">机构业务权限配置</div>
            <div class="checkbox-content">
              <a-checkbox-group v-model="Form.businessAuthorityIds">
                <a-checkbox
                  :value="i.id"
                  name="type"
                  v-for="(i, index) in organizationBusinessListData"
                  :key="index"
                >
                  {{ i.label }}
                </a-checkbox>
              </a-checkbox-group>
            </div>
          </div>

          <div class="configuration-title">启用/禁用：</div>
          <blank height="15"> </blank>
          <a-radio-group
            name="radioGroup"
            v-model="Form.enableNum"
            :disabled="isCreate == 1"
          >
            <a-radio :value="1"> 启用 </a-radio>
            <a-radio :value="2"> 禁用 </a-radio>
          </a-radio-group>
          <blank height="15"> </blank>
        </div>
      </div>
    </div>

    <bottomSuspension>
      <a-button :style="{ marginRight: '20px' }" @click="goback">
        返回
      </a-button>
      <a-button
        type="primary"
        :style="{ marginRight: '42px' }"
        @click="subMIt()"
        :disabled="isCreate == 1"
      >
        提交
      </a-button>
    </bottomSuspension>
    <a-modal
      v-model="visible"
      title="选择使用机构业务配置"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-checkbox-group v-model="checkboxList" :disabled="isCreate == 1">
        <a-checkbox
          v-for="(i, index) in appList"
          :key="index"
          :value="i.id"
          name="type"
        >
          {{ i.appName }}
        </a-checkbox>
      </a-checkbox-group>
    </a-modal>

    <!-- 用户选择弹窗 -->
    <user-select-modal
      :visible.sync="userModalVisible"
      :title="userModalTitle"
      :multiple="true"
      :selected-ids="currentSelectedIds"
      :fetch-api="fetchUserListApi"
      @confirm="handleUserConfirm"
    />
  </div>
</template>

<script>
import {
  getTreeList,
  queryList,
  getAppList,
  addOrganization,
  getOrganizationDetail,
  updateOrganization,
  organizationBusiness,
  queryListPage
} from "./api/api";
import UserSelectModal from "@/components/user-select-modal/index.vue";
export default {
  components: {
    UserSelectModal
  },
  data() {
    return {
      title: "创建机构",
      visible: false,
      treeData: [], // 组织机构树
      replaceFields: {
        key: "id",
        value: "id",
        children: "treeList",
        title: "organizationName"
      },
      queryUserList: [], // 所有搜索用户列表
      appList: [], // APP用用列表
      checkboxList: [], // 弹出选中的业务id
      id: "",
      isCreate: 2, // 1不可修改 2可修改
      isFlag: 1, // 上级目录flag
      Form: {
        organizationName: "",
        enableNum: 1,
        useAppIds: [],
        systemAdminIds: [],
        businessAuthorityIds: [] //机构业务权限配置复选框数据id
      },
      organizationBusinessListData: [], //机构业务权限配置复选框数据
      querypage: {
        page: 1,
        size: 10
      },
      queryPageData: [],
      isRequestStatus: null, // 是否有数据进行再次请求
      // 用户选择弹窗相关
      userModalVisible: false,
      userModalTitle: '选择人员',
      currentFieldName: '', // 当前操作的字段名
      currentSelectedIds: [], // 当前已选中的用户ID
      userNamesMap: {} // 存储各字段对应的用户姓名
    };
  },
  created() {
    getTreeList().then(res => {
      this.treeData = res.data.data;
    });
    getAppList().then(res => {
      this.appList = res.data.data;
    });
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.isCreate = this.$route.query.isCreate;
      if (this.isCreate == 1) {
        //查看
        this.$route.meta.title = this.title = "机构详情";
      } else {
        this.$route.meta.title = this.title = "编辑机构信息";
      }
      getOrganizationDetail({ id: this.$route.query.id }).then(res => {
        this.Form = res.data.data;
        this.checkboxList = this.Form.useAppIds;
        this.treeChange(this.Form.parentId);
      });
    }
    this.searchUser(), this.organizationBusinessFn();
    this.querypageFn();
  },
  computed: {
    isfinance: function() {
      let aa = this.Form.organizationName.search("财务");
      if (aa == -1) {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    // 分页党政领导
    popupScrollselect(e) {
      /**
       * @date 2023-4-19
       * @description :一下为之前写法 存在bug  偶尔不能下拉请求数据 复现频率高 但无任何报错 无法找到确切原因
       * 经研究发现浏览器分辨率导致scrollTop存在偏差 以至于不满足下列等式条件
       * @author qi
       */
      // const { scrollHeight, scrollTop, clientHeight } = e.target
      // if (scrollHeight - scrollTop === clientHeight) {
      //   this.querypage.page = this.querypage.page + 1
      //   this.querypageFn()
      // }

      /**
       * @date 2023-4-20
       * @description ：以上写法存在bug、以下代码为尝试解决
       * @author qi
       */
      let obj = e.target;
      // console.log(obj.scrollTop, obj.offsetHeight, obj.scrollHeight, '滑动了')
      if (obj.scrollTop + 1 + obj.offsetHeight >= obj.scrollHeight) {
        if (this.isRequestStatus) {
          this.querypage.page = this.querypage.page + 1;
          this.querypageFn();
        } else {
          // console.log('没数据了停止请求2')
        }
      }
    },
    querypageFn() {
      const params = {
        fullName: "",
        page: this.querypage.page,
        size: this.querypage.size
      };
      queryListPage(params).then(res => {
        if (res.data.code === 0) {
          if (res.data.data.length === 0) {
            this.isRequestStatus = false;
            return;
          } else {
            this.isRequestStatus = true;
            this.queryPageData = this.queryPageData.concat(res.data.data);
          }
        }
      });
    },
    // 输入框限制85
    eightyfive(v) {
      if (this.Form[v].length > 85) {
        this.Form[v] = this.Form[v].substring(0, 85);
        this.$message.destroy();
        this.$message.warning("只能输入85个字");
      }
    },
    // 组织树递归查找某一机构
    getTreeIt(dt, n) {
      let that = this;
      var value = null;
      for (const ev of dt) {
        if (ev.id == n) {
          value = ev;
          break;
        } else {
          if (ev.treeList && ev.treeList.length > 0) {
            const obj = that.getTreeIt(ev.treeList, n);
            if (obj) {
              return obj;
            }
          }
        }
      }
      return value;
    },
    treeChange(e) {
      let treeIt = this.getTreeIt(this.treeData, e);
      if (treeIt) {
        this.isFlag = treeIt.flag; //获取上级目录机构类型
      }
    },
    // 多选搜索按名字搜
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getApp(id) {
      // 根据id 获取业务
      return this.appList.find(obj => {
        if (obj.id == id) {
          return obj;
        }
      });
    },

    showModal() {
      // 弹出选择业务
      if (this.isCreate == 1) {
        return;
      } else {
        this.visible = true;
      }
    },
    handleOk(e) {
      //业务弹出点击确认
      this.visible = false;
      this.Form.useAppIds = this.checkboxList;
      // this.Form.manageAppIds = this.checkboxList
    },
    handleCancel() {
      //业务弹出点击取消
      this.checkboxList = this.Form.useAppIds;
    },
    searchUser() {
      queryList().then(res => {
        this.queryUserList = res.data.data;
      });
    },
    //提交
    subMIt() {
      // return
      //删除部分专属负责人
      if (this.Form.flag == 2) {
        // 公司
        delete this.Form.departmentHeadIds;
        delete this.Form.businessHeadIds;
        delete this.Form.approveLeadershipIds;
        delete this.Form.showdepartmentsHeadIds;
      } else {
        // 部门
        delete this.Form.administrativeDirectors;
        delete this.Form.governmentDirectors;
        delete this.Form.showLeadershipIds;
        if (this.Form.organizationName !== "综合办公室") {
          //不是综合办公室
          delete this.Form.generalChiefIds;
          delete this.Form.generalInfoIds;
          delete this.Form.generalSecretarialIds;
        }
      }
      if (!this.isfinance) {
        //删除财务经办人
        delete this.Form.financeAffairsIds;
      }
      if (this.id) {
        updateOrganization(this.Form).then(res => {
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            this.goback();
          }
        });
      } else {
        addOrganization(this.Form).then(res => {
          if (res.data.code == 0) {
            this.$message.success("添加成功");
            this.goback();
          }
        });
      }
    },
    goback() {
      this.$router.push("/InstitutionalFramework");
    },
    //获取机构业务权限配置复选框数据
    organizationBusinessFn() {
      organizationBusiness({}).then(res => {
        let { code, data } = res.data;
        if (code == 0) {
          this.organizationBusinessListData = data;
        }
      });
    },

    // ========== 新增：用户选择弹窗相关方法 ==========
    // 获取用户列表的 API 方法（供弹窗组件调用）
    fetchUserListApi(params) {
      return queryListPage(params);
    },

    // 打开用户选择弹窗
    openUserModal(fieldName, title) {
      this.currentFieldName = fieldName;
      this.userModalTitle = title;
      this.currentSelectedIds = this.Form[fieldName] || [];
      this.userModalVisible = true;
    },

    // 用户选择确认
    handleUserConfirm(result) {
      // 更新表单数据
      this.Form[this.currentFieldName] = result.ids;
      // 保存用户姓名用于显示
      this.$set(this.userNamesMap, this.currentFieldName, result.names);
    },

    // 获取用户姓名显示
    getUserNames(fieldName) {
      // 优先从缓存的姓名映射中获取
      if (this.userNamesMap[fieldName]) {
        return this.userNamesMap[fieldName];
      }
      
      // 如果没有缓存，从 queryUserList 中查找（用于编辑时的初始化）
      const ids = this.Form[fieldName];
      if (!ids || ids.length === 0) {
        return '';
      }
      
      const names = ids
        .map(id => {
          const user = this.queryUserList.find(u => u.id === id);
          return user ? user.fullName : '';
        })
        .filter(name => name)
        .join('、');
      
      // 缓存结果
      if (names) {
        this.$set(this.userNamesMap, fieldName, names);
      }
      
      return names;
    }
  }
};
</script>

<style lang="scss" scoped>
.addInstitutionalFramework {
  .newsDetial-header {
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .configuration {
        padding: 20px;
        color: rgba(80, 80, 80, 1);
        background-color: rgba(229, 229, 229, 0.3357142857142857);
        .configuration-title {
          color: rgba(0, 0, 0, 0.85);
          font-size: 14px;
        }
        // 新增复选框按钮组
        .checkbox-groupContent {
          padding-top: 20px;
          .checkbox-content {
            margin-top: 20px;
          }
        }

        .scrollX {
          // height: 170px;
          // overflow: auto;
          overflow-x: scroll;
        }

        // .scrollX::-webkit-scrollbar {
        //   display: none;
        // }
        .configuration-cont {
          height: 120px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          // flex-wrap: wrap;
          .business-cont {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            margin-left: 50px;
            .business-imgbgc {
              width: 38px;
              height: 38px;
              background-color: rgba(2, 120, 254, 1);
              border-radius: 4px;
              text-align: center;
              line-height: 38px;
              position: relative;
              .business-img {
                color: #fff;
                font-size: 20px;
              }
            }
            .business-addbgc {
              width: 38px;
              height: 38px;
              border-radius: 4px;
              border: rgba(217, 217, 217, 1) solid 2px;
              line-height: 30px;
              font-size: 30px;
              text-align: center;
              font-weight: bold;
            }
            .business-name {
              text-align: center;
              // width: 55px;
              margin-top: 8px;
              height: 18px;
              color: rgba(56, 56, 56, 1);
              font-size: 12px;
              line-height: 18px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
  margin-bottom: 10px;
}

// 用户选择按钮间距
.ml10 {
  margin-left: 10px;
}

.w200 {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/addInstitutionalFramework.vue